//@ts-nocheck
import React, { memo, createContext, useContext } from 'react';
import { Registry } from '@react-registry';
import { TriggerButton } from './Button/TriggerButton';
import { Buttons } from './toolbarComponents';
import styles from './style.module.css';
import { useRteFullScreen } from '../../../../../utils/hooks';
import { useSlateStatic } from 'slate-react';


const toolbarContext = createContext({});
export const useToolbarProps = () => useContext(toolbarContext);

const types = ['leaf', 'element', 'editorButtons'];


const ToolbarTest = memo((props) => {
    const {
        toolbarType = 'mainToolbar',
        contentStack = false,
        toolbarMode = 'advance',
        customToolbarComponents = {},
        fieldName,
        editorRef,
        FullScreenToggle
    } = props;
    const isFullScreen = useRteFullScreen(editorRef)
    const editor = useSlateStatic()

    const contextValue = { toolbarType, contentStack, toolbarMode, customToolbarComponents, editorRef, editor }

    return (
        <div className='toolbar-parent'>
            {toolbarType !== 'hoveringToolbar' && <div className={'rte-field-name'}>
                {fieldName}
            </div>}
            <div className={styles['toolbar-child-inline']}>
                <toolbarContext.Provider value={contextValue}>
                    {types.map((type) => <Buttons type={type} key={type} />)}
                </toolbarContext.Provider>
            </div>
            {isFullScreen ? (
                <div className={styles['full-screen-toggle']} >{FullScreenToggle}</div>
            ) : null}
        </div>

    )
}, (prev, next) => {
    return prev.FullScreenToggle === next.FullScreenToggle;
});

export default ToolbarTest;